function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useMemo, memo } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { ListCell } from '@cbhq/cds-web/cells';
import { SearchInput } from '@cbhq/cds-web/controls/SearchInput';
import { VStack, Box, Divider } from '@cbhq/cds-web/layout';
import { spacing } from '@cbhq/cds-web/tokens';
import FlagIcon from '../FlagIcon.js';
import messages from '../messages.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
function CountrySelector({
  goToLanguageScreen,
  countries,
  selectedCountryCode
}) {
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchText = _useState2[0],
    setSearchText = _useState2[1];
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const countryList = useMemo(() => {
    if (searchText) {
      return countries.filter(country => {
        return country.country_name.toLowerCase().includes(searchText.toLowerCase());
      });
    }
    return countries;
  }, [countries, searchText]);
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsxs(VStack, {
      width: "100%",
      children: [/*#__PURE__*/jsx(Box, {
        spacing: 2,
        children: /*#__PURE__*/jsx(SearchInput, {
          compact: true,
          value: searchText,
          onChangeText: setSearchText,
          placeholder: formatMessage(messages.searchPlaceholder)
        })
      }), /*#__PURE__*/jsx(Divider, {}), /*#__PURE__*/jsx(ScrollContainer, {
        children: countryList.map(country => {
          return /*#__PURE__*/jsx(ListCell, {
            media: /*#__PURE__*/jsx(FlagIcon, {
              countryCode: country.country_code
            }),
            outerSpacing: {
              spacing: 0
            },
            title: country.country_name,
            accessory: country.country_code === selectedCountryCode ? 'selected' : 'arrow'
            // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop
            ,

            onPress: () => goToLanguageScreen(country.country_code)
          }, country.country_code);
        })
      })]
    })
  });
}
const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${spacing[2]};
  overflow: scroll;

  /* firefox */
  scrollbar-width: none;
  /* chrome */
  &::-webkit-scrollbar {
    display: none;
  }
`;
const CountrySelector$1 = /*#__PURE__*/memo(CountrySelector);
export { CountrySelector$1 as default };
//# sourceMappingURL=CountrySelector.js.map
